// extracted by mini-css-extract-plugin
export default {"mainContainer":"lists_mainContainer__EObgg","mainContent":"lists_mainContent__3CBeX","cards":"lists_cards__imBQk","card":"lists_card__YYIuI","pagination":"lists_pagination__VlQbT"};